import './App.css';
import Sidebar from './Sidebar';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useCookies } from 'react-cookie';
import './Main.css';
import { FaSearch } from "react-icons/fa";
import Background from './Background';
import { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import { useParams, useHistory } from 'react-router-dom';

function PropertyList() {

    const [cookies, setCookie] = useCookies(['user']);
    const [propertyList,setPropertyList] = useState([]);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [lastPage,setLastPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState("");
    const [buy,setBuy] = useState(1);
    const [type, setType] = useState(2);
    const [empty, setEmpty] = useState(1);
    const [isLoading, setIsLoading] = useState(false);

    const getPropertyList = () => {
        var data = new FormData();
        if(buy == 1) {
            data.append("buy", 0);
            data.append("rent", 1);
        } else {
            data.append("buy",1);
            data.append("rent", 0);
        }
        
        if(type == 0) {
            data.append("home", 1);
            data.append("apartment", 0);
            data.append("commercial", 0);
            data.append("coworking_space",0);
        } else if(type == 1) {
            data.append("home", 0);
            data.append("apartment", 1);
            data.append("commercial", 0);
            data.append("coworking_space",0);
        } else if(type == 2) {
            data.append("home", 0);
            data.append("apartment", 0);
            data.append("commercial", 1);
            data.append("coworking_space",0);
        } else if(type == 3) {
	    data.append("home",0);
            data.append("apartment",0);
            data.append("commercial",0);
            data.append("coworking_space",1);
	}
       
        if(empty == 0) {
            data.append("empty", 1);
            data.append("furnished", 0);
        } else if(empty == 1) {
            data.append("empty", 0);
            data.append("furnished", 1);
        }
        
        data.append("new",0);
        data.append("user_id", cookies.id);
        data.append("page",page);
        data.append("page_size",pageSize);
        if(searchTerm != "") {
            data.append("search", searchTerm);
        }
        setIsLoading(true);
        fetch('https://api.connecker.com/api/get_properties', {
            method: 'POST',
            body: data
        }).then(res => {
            setIsLoading(false);
            if(!res.ok) {
                throw Error('Could not fetch');
            }
            return res.json();
         }).then(data => {
            setIsLoading(false);
            if(data.response_code == 200) {
               setPropertyList(data.data);
               setPage(data.page);
               setLastPage(data.last_page);
            } else if(data.response_code == 404) {
                setPropertyList([]);
            }
         });
    }

    const nextPage = () => {
        setPage(page+1);
    }

    const previousPage = () => {
        setPage(page-1);
    }

    useEffect(() => {
        const abortController = new AbortController();
        getPropertyList();
       },[page,pageSize, searchTerm, buy, type, empty]);

    return(
        <div className="content">
          <div className="row pb-2">
                <div className="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
                    <Sidebar></Sidebar>
                </div>
                <div className="col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 col-xxl-10" style={{ paddingLeft: "40px" }}>
                    <Background></Background>
                    <h4 className="heading" style={{ color:"white", marginTop:"50px" }}>Property List - Commercial</h4>
                    
                    {/* Filter Controls */}
                    <div className="card mb-3" style={{borderColor:"white", padding: "20px"}}>
                        <div className="row align-items-center">
                            <div className="col-md-2">
                                <div className="d-flex align-items-center">
                                    <span className="me-2" style={{fontSize: "14px", color: "#666"}}>Show</span>
                                    <select 
                                        name="entries" 
                                        id="entries" 
                                        className="form-select form-select-sm"
                                        style={{width: "70px", fontSize: "14px"}}
                                        onChange={({ target: { value } }) => setPageSize(value)}
                                    >
                                        <option value="10">10</option>
                                        <option value="20">20</option>
                                        <option value="50">50</option>
                                        <option value="100">100</option>
                                    </select>
                                    <span className="ms-2" style={{fontSize: "14px", color: "#666"}}>entries</span>
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="d-flex align-items-center">
                                    <span className="me-2" style={{fontSize: "14px", color: "#666"}}>Sale/Rent</span>
                                    <select 
                                        name="buy" 
                                        id="buy" 
                                        className="form-select form-select-sm"
                                        style={{fontSize: "14px"}}
                                        onChange={({ target: { value } }) => setBuy(value)}
                                    >
                                        <option value="0">Buy</option>
                                        <option value="1" defaultSelected>Rent</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="d-flex align-items-center">
                                    <span className="me-2" style={{fontSize: "14px", color: "#666"}}>Type</span>
                                    <select 
                                        name="type" 
                                        id="type" 
                                        className="form-select form-select-sm"
                                        style={{fontSize: "14px"}}
                                        onChange={({ target: { value } }) => setType(value)}
                                    >
                                        <option value="0">Home</option>
                                        <option value="1">Apartment</option>
                                        <option value="2" defaultSelected>Commercial</option>
                                        <option value="3">Coworking Space</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="d-flex align-items-center">
                                    <span className="me-2" style={{fontSize: "14px", color: "#666"}}>Empty/Furnished</span>
                                    <select 
                                        name="empty" 
                                        id="empty" 
                                        className="form-select form-select-sm"
                                        style={{fontSize: "14px"}}
                                        onChange={({ target: { value } }) => setEmpty(value)}
                                    >
                                        <option value="0">Empty</option>
                                        <option value="1" defaultSelected>Furnished</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="d-flex align-items-center justify-content-end">
                                    <span className="me-2" style={{fontSize: "14px", color: "#666"}}>Search:</span>
                                    <input 
                                        type="text" 
                                        id="listSearch" 
                                        className="form-control form-control-sm"
                                        style={{width: "150px", fontSize: "14px"}}
                                        placeholder="Search..."
                                        onChange={({ target: { value } }) => setSearchTerm(value)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Table */}
                    <div className="card" style={{borderColor:"white"}}>
                        <div className="table-responsive">
                            <table style={{width:"100%"}} className="table table-striped">
                                <thead style={{backgroundColor: "#f8f9fa"}}>
                                    <tr style={{ borderBottom: "2px solid #dee2e6" }}>
                                        <th style={{color: "#666", fontWeight: "600", fontSize: "14px", padding: "12px 8px"}}>#</th>
                                        <th style={{color: "#666", fontWeight: "600", fontSize: "14px", padding: "12px 8px"}}>PROPERTY</th>
                                        <th style={{color: "#666", fontWeight: "600", fontSize: "14px", padding: "12px 8px"}}>ADDRESS</th>
                                        <th style={{color: "#666", fontWeight: "600", fontSize: "14px", padding: "12px 8px"}}>BEDS</th>
                                        <th style={{color: "#666", fontWeight: "600", fontSize: "14px", padding: "12px 8px"}}>SQ. FT</th>
                                        <th style={{color: "#666", fontWeight: "600", fontSize: "14px", padding: "12px 8px"}}>AGENT</th>
                                        <th style={{color: "#666", fontWeight: "600", fontSize: "14px", padding: "12px 8px"}}>SALE/RENT</th>
                                        <th style={{color: "#666", fontWeight: "600", fontSize: "14px", padding: "12px 8px"}}>PRICE</th>
                                        <th style={{color: "#666", fontWeight: "600", fontSize: "14px", padding: "12px 8px"}}>ACTIONS</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {
                                    propertyList.map((property, i) => (
                                            <tr key={property.id} style={{borderBottom: "1px solid #eee"}}>
                                                <td style={{padding: "12px 8px", fontSize: "14px", color: "#333"}}>
                                                    {(page - 1) * pageSize + i + 1}
                                                </td>
                                                <td style={{padding: "12px 8px", fontSize: "14px", color: "#333"}}>
                                                    {property.name}
                                                </td>
                                                <td style={{padding: "12px 8px", fontSize: "14px", color: "#666"}}>
                                                    {property.address}
                                                </td>
                                                <td style={{padding: "12px 8px", fontSize: "14px", color: "#333"}}>
                                                    {property.beds} BHK
                                                </td>
                                                <td style={{padding: "12px 8px", fontSize: "14px", color: "#333"}}>
                                                    {property.project_area ? `${property.project_area}` : '-'}
                                                </td>
                                                <td style={{padding: "12px 8px", fontSize: "14px", color: "#333"}}>
                                                    {property.email}
                                                </td>
                                                <td style={{padding: "12px 8px"}}>
                                                    { property.buy == 0 ? 
                                                        <span style={{ 
                                                            padding: "4px 12px", 
                                                            backgroundColor: "#ff6b35", 
                                                            borderRadius: "12px", 
                                                            color: "white", 
                                                            fontSize: "12px", 
                                                            fontWeight: "500",
                                                            display: "inline-block",
                                                            textAlign: "center",
                                                            minWidth: "50px"
                                                        }}>RENT</span> : 
                                                        <span style={{ 
                                                            padding: "4px 12px", 
                                                            backgroundColor: "#28a745", 
                                                            borderRadius: "12px", 
                                                            color: "white", 
                                                            fontSize: "12px", 
                                                            fontWeight: "500",
                                                            display: "inline-block",
                                                            textAlign: "center",
                                                            minWidth: "50px"
                                                        }}>SALE</span> 
                                                    }
                                                </td>
                                                <td style={{padding: "12px 8px", fontSize: "14px", fontWeight: "600", color: "#333"}}>
                                                    ${property.price ? parseFloat(property.price).toLocaleString() : '0'}
                                                </td> 
                                                <td style={{padding: "12px 8px"}}>
                                                    <Link 
                                                        to={`/property/${property.id}`} 
                                                        style={{
                                                            color: "#007bff",
                                                            textDecoration: "none",
                                                            fontSize: "14px",
                                                            fontWeight: "500"
                                                        }}
                                                    >
                                                        View
                                                    </Link>
                                                </td>
                                            </tr>
                                    ))
                                }
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="row d-flex justify-content-between">
                            <div className="col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                                
                            </div>
                            <div className="col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                                <div>
                                    {((page > 1) && propertyList.length > 0) ? <button type="button" onClick={ previousPage } class="btn btn-outline-secondary">Previous</button> : <div></div> }
                                    {((lastPage > page) && propertyList.length > 0) ? <button type="button" style={{ color:"#FF4500" }} onClick={ nextPage } class="btn btn-outline-secondary">Next</button> : <div></div>}
                                </div>
                            </div>
                        </div> 
                </div>
            </div>
        </div>
    );
}

export default PropertyList;
